import React, { useEffect, useState } from 'react';

import { DicePro } from 'react-dice-pro';

import rollingSound from './sounds/dice-sound.mp3';

import './App.css';

import { getRandomInt } from './utills';

const App = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [rollTrigger, setRollTrigger] = useState(0);
  const [targetFace, setTargetFace] = useState(null);

  useEffect(() => {
    const isMobile = window.screen.width < 700;

    Particles.init({
      selector: '#particles-js',
      color: '#ffffff',
      connectParticles: true,
      maxParticles: isMobile === true ? 30 : 110,
      sizeVariations: 3,
      speed: 0.4,
      onClick: { enable: true, mode: 'push' },
    });

    return () => {
      Particles.destroy();
    };
  }, []);

  const handlePlay = async () => {
    if (isPlaying === true) {
      return;
    }

    const randomInt = getRandomInt(1, 6);

    setIsPlaying(true);

    setTargetFace(randomInt);
    setRollTrigger((prevState) => prevState + 1);
  };

  const handleRollComplete = () => {
    setIsPlaying(false);
  };

  return (
    <>
      <main className="main-section">
        <h1 className="heading">Roll the dice!</h1>
        <DicePro
          targetFace={targetFace}
          soundSrc={rollingSound}
          rollTrigger={rollTrigger}
          onRollComplete={handleRollComplete}
        />
        <button
          className="spin-button"
          type="button"
          onClick={handlePlay}
          disabled={isPlaying}
        >
          Roll
        </button>
      </main>
      <canvas id="particles-js" />
    </>
  );
};

export { App };
